define('home/views/MainLayout',[
    'jquery',
    'underscore',
    'backbone',
    'backbone-marionette',

    'core/bus',
    'core/utils/metatags',

    'home/mixins/asEmbedLayout',
    'home/mixins/withClickLinkTracking',
    'home/utils/trackingUtils',
    'home/utils/sidebarUtils',

    'home/models/Session',
    'home/views/NavView',
    'home/views/MessageCollectionView',

    'home/templates/mainLayout',
], function (
    $,
    _,
    Backbone,
    Marionette,

    bus,
    metatags,

    asEmbedLayout,
    withClickLinkTracking,
    trackingUtils,
    sidebarUtils,

    Session,
    NavView,
    MessageCollectionView,

    mainLayoutTemplate
) {
    'use strict';

    var parent = Marionette.Layout;
    var parentProto = parent.prototype;

    var MainLayout = parent.extend({
        id: 'container-page',

        template: mainLayoutTemplate,

        serializeData: function () {
            var data = parentProto.serializeData.apply(this, arguments);

            var user = this.session.user;
            if (user && user.toJSON)
                _.extend(data, user.toJSON());

            // for survey monkey link in nav bar
            var userId = Session.fromCookie().id;
            if (userId)
                data.userId = userId;

            data.isSidebar = sidebarUtils.isSidebar();
            data.messages = this.app.messages;

            return data;
        },

        events: {
            // Need to specify specific areas to track click from, otherwise all
            // clicks from all subviews will be tracked both here and by the
            // subviews themselves.
            'click [data-jester-area=drawer_footer] a[data-link-name]': 'trackClickLink',
            'click [data-jester-area=mobile_sidebar] a[data-link-name]': 'trackClickLink',
        },

        regions: {
            content: {
                selector: '#container-main',
            },
            nav: '[data-role=nav-view]',
            alerts: '[data-role=messages-view]',
        },

        initialize: function (options) {
            this.container = options.container;
            this.session = options.session;
            this.app = options.app;

            this.windowHeight = $(window).height();
            $(window).resize(
                _.bind(function () {
                    this.windowHeight = $(window).height();
                    this.toggleHeight();
                }, this)
            );
        },

        onRender: function () {
            $(this.container).html(this.$el);

            // don't show NavView in sidebar
            if (sidebarUtils.isSidebar())
                return;

            this.nav.show(new NavView({
                app: this.app,
            }));

            var messages = new Backbone.Collection(this.app.messages);

            this.alerts.show(new MessageCollectionView({
                collection: messages,
            }));
        },

        showView: function (view, options) {
            if (!this.rendered) {
                // This is essentially lazy rendering of MainLayout.
                // It relieves us of having to find or create the right
                // place to render the MainLayout in the course of app
                // initialization.
                this.render();
                this.rendered = true;
            }

            options = options || {};
            this.updateBackgroundClass(options.lightBackground);

            if (view.getPageTrackingParams)
                trackingUtils.setPageParams(view.getPageTrackingParams());

            // Clear previous fill preferences
            this.$(this.content.el).removeData('height');

            if (this.content.currentView)
                this.stopListening(this.content.currentView);

            this.listenTo(view, 'all', this.handleContentEvents);

            this.content.show(view);

            // Set the metatags and title for the page. `getMetaAttrs` returns
            // either a promise or a truthy object. If the view does not have a
            // `getMetaAttrs` method, we default to an empty dictionary which
            // resolves the $.when.
            $.when(view.getMetaAttrs ? view.getMetaAttrs() : {})
                .then(metatags.set);

            bus.trigger('viewSection');
        },

        updateBackgroundClass: function (lightBackground) {
            this.$el.toggleClass('bg--light', Boolean(lightBackground));
        },

        /*
         * Handles special events propogated up from the content view and its subviews.
         *
         * @param  {string} eventName - The name of the event triggered, with possible
         *                              prefixes from parent views that propogated the
         *                              event, ex: itemView:<orig event name>
         * @param  {View(s)} - Any parent views that propogated the event, ex:
         *                     CollectionView, FetchableCollectionView
         * @param  {*} - Any params passed to the original event
         */
        handleContentEvents: function (eventName) {
            // By checking the exact eventName, this only listens to events from the
            // top level view in the content region of this layout.
            if (eventName === 'show' || eventName === 'render')
                this.toggleHeight();  // Update the height of the content container
            // Check for a toggleHeight event on any (sub)view in the content region
            else if (/toggleHeight/.test(eventName))
                // Grab the the argument passed to the original event. Should be the height preference to use.
                this.toggleHeight(_.last(arguments));
        },

        /**
         * Updates the content container to fill either the height of the
         * window or to remain the height of its content. Saves the given
         * preference on the container while it is showing this view.
         *
         * @param {('fill'|'content')} [heightPreference] - fill, by default
         */
        toggleHeight: function (heightPreference) {
            if (!this.content || !this.content.$el)
                return;

            if (!heightPreference)
                // The default height preference, if not explicitly specified otherwise, is fill
                heightPreference = this.content.$el.data('height') || 'fill';

            var minHeight;

            switch (heightPreference) {
            case 'fill':
                this.navHeight = this.navHeight || (this.nav.$el ? this.nav.$el.height() : 0);
                minHeight = (this.windowHeight - this.navHeight) + 'px';
                break;
            case 'content':
                // pass empty string to jquery to clear previously set value
                minHeight = '';
            }

            this.content.$el
                .css({ 'min-height': minHeight })
                .data({ height: heightPreference });
        },
    });

    if (sidebarUtils.isSidebar())
        asEmbedLayout.call(MainLayout.prototype);

    withClickLinkTracking.call(MainLayout.prototype);

    return MainLayout;
});

